import React from "react";

export const CloseButton = ({ style = {}, onClick = () => { } }) => {
  return (
    <div onClick={onClick} style={{ position: "absolute", top: "10px", right: "20px", cursor: "pointer", ...style }}><i className="fa fa-times" /></div>
  )
}

export default CloseButton;
